import { isEmpty } from "lodash";

export const disableSelectOptions = (options, selectedValues) => {
  if (!selectedValues || isEmpty(selectedValues)) {
    return options;
  }

  return options.map((o) => {
    const alreadySelected = selectedValues.some((f) => f?.Name === o.value);

    return {
      ...o,
      disabled: o.disabled || alreadySelected,
    };
  });
};
